import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Button,
  Box,
  Menu,
  FormControlLabel,
  Checkbox,
  TextField,
  Typography,
  Card,
  CardContent,
  Breadcrumbs,
  Stack,
  CircularProgress,
  Alert,
  Fade,
  Paper,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Dialog,
  DialogContent,
  InputAdornment,
  Switch,
  TableSortLabel,
} from "@mui/material";
import NavBar from "./NavBar";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { useTheme } from "@emotion/react";
import { BUTTON_STYLES } from "../styles/componentStyles";
import api from "../axiosInstance";
import NotificationModal from "./NotificationModal";
import NotificationAddIcon from "@mui/icons-material/NotificationAdd";
import FilterBar from "./Reusable/FilterBar";
// Column config and visibility state
const allColumns = [
  {
    key: "id",
    label: "ID",
    cellCss: { align: "center", minWidth: "50px" },
    getValue: (r) => r.id,
  },
  {
    key: "bookId",
    label: "Book Id",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.bookId,
  },
  {
    key: "userId",
    label: "UserId",
    getValue: (r) => r.userId,
  },
  {
    key: "universityId",
    label: "University Id",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.universityId,
  },
  {
    key: "courseId",
    label: "Course Id",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.courseId,
  },
  {
    key: "semesterId",
    label: "Semester Id",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.semesterId,
  },
  {
    key: "regulationYearId",
    label: "Regulation Id",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.regulationYearId,
  },
  {
    key: "collegeId",
    label: "College Id",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.collegeId,
  },
  {
    key: "firstName",
    label: "First Name",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r.firstName,
  },

  {
    key: "bookTitle",
    label: "Book Title",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r.bookTitle,
  },
  {
    key: "universityName",
    label: "University Name",
    cellCss: { align: "center", minWidth: "140px" },
    getValue: (r) => r.universityName,
  },
  {
    key: "courseName",
    label: "Course Name",
    cellCss: { align: "center", minWidth: "200px" },
    getValue: (r) =>
      r.courseSemesters?.map((item) => item.courseName).join(", ") || "—",
  },
  {
    key: "semesterName",
    label: "Semester Name",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) =>
      r.courseSemesters?.map((item) => item.semesterName).join(", ") || "—",
  },
  {
    key: "regulationName",
    label: "Regulation",
    cellCss: { align: "center", minWidth: "140px" },
    getValue: (r) => r.regulationName,
  },
  {
    key: "collegeName",
    label: "College Name",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.collegeName,
  },

  {
    key: "email",
    label: "Email",

    getValue: (r) => r.email,
  },
  {
    key: "requestType",
    label: "Request Type",

    getValue: (r) => r.requestType,
  },
  {
    key: "whatsappPhoneNumber",
    label: "Whatsapp Number",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.whatsappPhoneNumber,
  },
];
const defaultVisibleKeys = new Set([
  "bookId",
  "userId",
  "bookTitle",
  "firstName",
  "email",
  "collegeName",
  "universityName",
  "courseName",
  "semesterName",
  "regulationName",
  "publisherName",
  "whatsappPhoneNumber",
]);

const STORAGE_KEY = "notificationsVisibleColumns";
function Notification() {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [notification, setNotifcation] = useState([]);
  const [states, setStates] = useState([]);
  const [openNew, setOpenNew] = useState(false);
  const handleNewClose = () => setOpenNew(false);
  const [selectedstates, setSelectedStates] = useState("1" || "");
  const [searchQuery, setSearchQuery] = useState(() => {
    return localStorage.getItem("notify_management") || "";
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [open, setOpen] = useState(false);
  const [totalElements, setTotalElements] = useState(0);
  const [openImage, setOpenImage] = useState(null);
  const [bannerEdit, setBannerEdit] = useState(null);
  const [dense, setDense] = useState(true);
  const [orderBy, setOrderBy] = useState("title");
  const [order, setOrder] = useState("asc");
  const [courseSearch, setCourseSearch] = useState("");
  const [universitySearch, setUniversitySearch] = useState("");
  const [semesterSearch, setSemesterSearch] = useState("");
  const [regulation, Regulation] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [universityId, setUniversityId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [semesterId, setSemesterId] = useState("");
  const [regulationId, setRegulationId] = useState("");
  const [isFiltersLoadeds, setisFiltersLoadeds] = useState(false);

  // Editing page data in onclick
  //   const handleEditClick = (rowData) => {
  //     handleNewOpen();
  //     setNewsEdit(rowData);
  //   };
  // Save to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("notify_management", searchQuery);
  }, [searchQuery]);
  // Sorting logic
  const handleSort = (columnKey) => {
    const isAsc = orderBy === columnKey && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(columnKey);
  };

  const sortedData = useMemo(() => {
    if (!notification) return [];

    return [...notification].sort((a, b) => {
      if (!orderBy) return 0;

      const aValue = a[orderBy];
      const bValue = b[orderBy];

      if (aValue == null) return 1;
      if (bValue == null) return -1;

      if (typeof aValue === "string") {
        return order === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      if (typeof aValue === "number") {
        return order === "asc" ? aValue - bValue : bValue - aValue;
      }

      return 0;
    });
  }, [notification, orderBy, order]);

  // padding Dense
  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  // opening Adding page data in onclick
  const handleNewOpen = () => {
    setOpenNew(true);
  };

  const [visibleColumns, setVisibleColumns] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) {
          const validKeys = new Set(allColumns.map((c) => c.key));
          const filtered = arr.filter((k) => validKeys.has(k));
          if (filtered.length > 0) {
            return new Set(filtered);
          }
        }
      }
    } catch {}
    return new Set(Array.from(defaultVisibleKeys));
  });
  const [columnsMenuAnchor, setColumnsMenuAnchor] = useState(null);
  const openColumnsMenu = Boolean(columnsMenuAnchor);

  // Persist column config to localStorage on change
  useEffect(() => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(Array.from(visibleColumns)),
      );
    } catch {}
  }, [visibleColumns]);

  const handleOpenColumnsMenu = (e) => setColumnsMenuAnchor(e.currentTarget);
  const handleCloseColumnsMenu = () => setColumnsMenuAnchor(null);
  const toggleColumn = (key) => {
    setVisibleColumns((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };
  // Helper function to get content type chip styling
  const getContentTypeChip = (type) => {
    const typeConfig = {
      text: { color: "primary", label: "Text" },
      image: { color: "secondary", label: "Image" },
      video: { color: "success", label: "Video" },
      link: { color: "info", label: "Link" },
    };

    const config = typeConfig[type?.toLowerCase()] || {
      color: "default",
      label: type || "Unknown",
    };
    return <Chip label={config.label} color={config.color} size="small" />;
  };
  //   Page nation handel changes
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // page nation rows handles
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };
  //   // pagenation code
  const paginatedNotification = notification.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );
  // Columns Field showing obeject
  const visibleColumnDefs = allColumns.filter((c) => visibleColumns.has(c.key));
  // Deletion confirm dialog box open and close.
  const handleClickOpen = (id) => {
    setOpen(true);
  };

  const handleChange = (event) => {
    setSelectedStates(event.target.value);
  };

  console.log(notification);

  // Notify me users data get api fetching
  useEffect(() => {
    if (!isFiltersLoadeds) return;

    setIsLoading(true);
    api
      .get(`/api/book-notifications/getalldata`, {
        params: {
          page,
          size: rowsPerPage,
          universityId: universityId,
          courseId: courseId,
          regulationId: regulationId,
          semesterId: semesterId,
        },
      })
      .then((res) => {
        const data = res.data;
        setNotifcation(data.data.items);
        setTotalElements(
          typeof data.data.totalElements === "number"
            ? data.data.totalElements
            : 0,
        );
        setError(null);
      })
      .catch((error) => {
        console.log(error);
        setError(error);
      })
      .finally(() => setIsLoading(false));
  }, [
    rowsPerPage,
    page,
    universityId,
    courseId,
    regulationId,
    semesterId,
    isFiltersLoadeds,
  ]);

  // Then filter the sortedData
  const FiletredData = sortedData.filter((row) => {
    const matchesTitle =
      !regulation ||
      row.regulationName
        ?.toLowerCase()
        .includes(regulation.toLowerCase().trim());
    console.log(row);

    const matchesUniversity =
      !universitySearch ||
      row.publisherName
        ?.toLowerCase()
        .includes(universitySearch.toLowerCase().trim());
    const matchesCourse =
      !courseSearch ||
      row.courseSemesters?.some((c) =>
        c.courseName?.toLowerCase().includes(courseSearch.toLowerCase().trim()),
      );
    console.log(courseSearch);

    const matchesSemester =
      !semesterSearch ||
      (Array.isArray(row.courseSemesters) &&
        row.courseSemesters.some((c) =>
          c.semesterName
            ?.toLowerCase()
            .includes(semesterSearch.toLowerCase().trim()),
        ));

    // Return true only if all conditions match
    return (
      matchesTitle && matchesCourse && matchesUniversity && matchesSemester
    );
  });
  // Helper function to get boolean chip styling
  const getBooleanChip = (value) => {
    const normalized = value === true || value === "true" || value === "Yes";
    return (
      <Chip
        label={normalized ? "Yes" : "No"}
        color={normalized ? "success" : "error"}
        size="small"
        variant="outlined"
      />
    );
  };

  // chekck  box selected ids
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIds = FiletredData.map((row) => row.userId);
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id],
    );
  };

  const isSelected = (id) => selectedRows.includes(id);

  //  Load saved filters AFTER lists are loaded

  useEffect(() => {
    const savedFilters = JSON.parse(
      localStorage.getItem("NotificationsFilters"),
    );
    if (savedFilters) {
      setUniversityId(savedFilters.universityId || "");
      setCourseId(savedFilters.courseId || "");
      setSemesterId(savedFilters.semesterId || "");
      setRegulationId(savedFilters.regulationId || "");
    }
    setisFiltersLoadeds(true);
  }, []);

  //  Save filters whenever any change happens
  useEffect(() => {
    if (!isFiltersLoadeds) return;
    const filtersToSave = {
      universityId,
      courseId,
      semesterId,
      regulationId,
    };
    localStorage.setItem("NotificationsFilters", JSON.stringify(filtersToSave));
  }, [universityId, courseId, semesterId, regulationId, isFiltersLoadeds]);
  // reset the Local saved filters
  const [rotating, setRotating] = useState(false);
  const handleResetFilters = () => {
    setUniversityId("");
    setCourseId("");
    setSemesterId("");
    setRegulationId("");
    localStorage.removeItem("NotificationsFilters");
  };
  const handleClick = () => {
    setRotating(true);
    handleResetFilters?.();

    // Stop rotation after animation completes
    setTimeout(() => setRotating(false), 600); // match animation duration
  };
  return (
    <>
      {/* <NavBar /> */}
      <ToastContainer />
      {/* <Card sx={{ mb: 3, boxShadow: 2, width: "100%", mt: 2 }}>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Box>
              <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
                <Link underline="hover" color="inherit" to="/booklist">
                  Books List
                </Link>
                <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
                  Notification Management
                </Typography>
              </Breadcrumbs>
              <Typography
                variant="h4"
                component="h1"
                sx={{ fontWeight: 600, color: "primary.main" }}
              >
                Notify me users Data
              </Typography>
            </Box>
            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={() => window.location.reload()}
              disabled={isLoading}
              sx={{ minWidth: 120 }}
            >
              {isLoading ? <CircularProgress size={20} /> : "Refresh"}
            </Button>
          </Box>
          <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
           
            <Button
              variant="outlined"
              startIcon={<ViewColumnIcon />}
              onClick={handleOpenColumnsMenu}
              sx={{ minWidth: 120 }}
            >
              Columns
            </Button>
            <Menu
              anchorEl={columnsMenuAnchor}
              open={openColumnsMenu}
              onClose={handleCloseColumnsMenu}
            >
              {allColumns.map((col) => (
                <FormControlLabel
                  key={col.key}
                  control={
                    <Checkbox
                      checked={visibleColumns.has(col.key)}
                      onChange={() => toggleColumn(col.key)}
                    />
                  }
                  label={col.label}
                  sx={{ pl: 1, pr: 2 }}
                />
              ))}
            </Menu>
          </Stack>
        </CardContent>
      </Card> */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" }, // column on mobile, row on desktop
          justifyContent: { xs: "flex-start", md: "space-between" }, // start on mobile, space-between on desktop
          alignItems: { xs: "stretch", md: "center" }, // stretch on mobile, center on desktop
          gap: { xs: 1, md: 0 }, // spacing between items
          mb: 2,
          marginLeft: "10px",
          marginTop: "10px",
        }}
      >
        {/* <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
          <Link underline="hover" color="inherit" to="/booklist">
            Books List
          </Link>
          <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
            Notification Management
          </Typography>
        </Breadcrumbs> */}
        <Box></Box>
        <Box>
          <Stack
            direction="row"
            spacing={2}
            flexWrap="wrap"
            useFlexGap
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              gap: 1,
              flexWrap: { xs: "wrap", md: "nowrap" }, // wrap buttons on mobile
              mt: { xs: 1, md: 0 },
              marginRight: "10px",
            }}
          >
            <Button
              variant="outlined"
              startIcon={<ViewColumnIcon />}
              onClick={handleOpenColumnsMenu}
              sx={{
                minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                fontSize: { xs: "10px", md: "12px" },
              }}
            >
              Columns
            </Button>
            <Menu
              anchorEl={columnsMenuAnchor}
              open={openColumnsMenu}
              onClose={handleCloseColumnsMenu}
              PaperProps={{
                sx: {
                  width: 200,
                  maxHeight: 500,
                  overflowY: "auto",
                  borderRadius: 2,
                },
              }}
            >
              {allColumns.map((col) => (
                <FormControlLabel
                  key={col.key}
                  control={
                    <Checkbox
                      checked={visibleColumns.has(col.key)}
                      onChange={() => toggleColumn(col.key)}
                    />
                  }
                  label={col.label}
                  sx={{ pl: 1, pr: 2 }}
                />
              ))}
            </Menu>
            <Button
              variant="contained"
              color="primary"
              startIcon={<NotificationAddIcon />}
              onClick={handleNewOpen}
              sx={{
                minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                fontSize: { xs: "10px", md: "12px" },
              }}
            >
              Add Notifications
            </Button>
          </Stack>
        </Box>
      </Box>
      {/* Search Section */}
      <Card sx={{ margin: { xs: "0 8px", md: "0 12px" }, boxShadow: 1 }}>
        <CardContent>
          <Box
            sx={{
              minWidth: "80%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {/* <Box
              sx={{
                minWidth: { xs: "80%", md: "50%" },
                display: "flex",
                width: "40%",
                alignItems: "center",
                gap: 2,
              }}
            >
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                placeholder="Search by Title,bookID,Name,College or Publisher..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
                sx={{ maxWidth: 400 }}
              />
              <Typography
                sx={{ display: { xs: "none", md: "block" } }}
                variant="body2"
                color="text.secondary"
              >
                {
                  sortedData.filter((notify) => {
                    const search = searchQuery.toLowerCase();
                    return [
                      notify.bookTitle,
                      notify.bookId,
                      notify.firstName,
                      notify.collegeName,
                      notify.publisherName,
                    ].some((field) =>
                      field?.toString().toLowerCase().includes(search)
                    );
                  }).length
                }{" "}
                of {notification.length} notification items
              </Typography>
            </Box> */}
            <Box
              sx={{
                minWidth: "95%",
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              {/* <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
                <TextField
                  sx={{ width: { xs: "100%", md: "23%" } }}
                  size="small"
                  variant="outlined"
                  label="Search University"
                  placeholder="Search by University..."
                  value={universitySearch}
                  onChange={(e) => setUniversitySearch(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  sx={{ width: { xs: "100%", md: "23%" } }}
                  size="small"
                  variant="outlined"
                  label="Search Course"
                  placeholder="Search by Course..."
                  value={courseSearch}
                  onChange={(e) => setCourseSearch(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  sx={{ width: { xs: "100%", md: "23%" } }}
                  size="small"
                  variant="outlined"
                  label="Search Semester"
                  placeholder="Search by Semester..."
                  value={semesterSearch}
                  onChange={(e) => setSemesterSearch(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  sx={{ width: { xs: "100%", md: "23%" } }}
                  size="small"
                  variant="outlined"
                  label="Search Regulation"
                  placeholder="Search by Regulation..."
                  value={regulation}
                  onChange={(e) => Regulation(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Stack> */}
              <FilterBar
                universityId={universityId}
                courseId={courseId}
                semesterId={semesterId}
                regulationId={regulationId}
                setUniversityId={setUniversityId}
                setCourseId={setCourseId}
                setSemesterId={setSemesterId}
                setRegulationId={setRegulationId}
              />
              <Box sx={{ display: { xs: "none", md: "block" } }}>
                <Button
                  onClick={handleClick}
                  variant="outlined"
                  sx={{
                    minWidth: "20px",
                    padding: "4px 4px",
                    borderRadius: "10px",
                    fontWeight: 600,
                    textTransform: "none",
                    color: "#17479e",
                    borderColor: "#17479e",
                    backgroundColor: "#f8f9ff",
                    transition: "all 0.3s ease",
                    boxShadow: "0 0 0 rgba(0,0,0,0)",
                    "&:hover": {
                      backgroundColor: "#17479e",
                      color: "#fff",
                      borderColor: "#17479e",
                      transform: "scale(1.05)",
                      boxShadow: "0 3px 10px rgba(25, 118, 210, 0.3)",
                    },
                    "&:active": {
                      transform: "scale(0.98)",
                    },
                  }}
                >
                  <RefreshIcon
                    sx={{
                      animation: rotating ? "spin 0.6s linear" : "none",
                      "@keyframes spin": {
                        "0%": { transform: "rotate(0deg)" },
                        "100%": { transform: "rotate(360deg)" },
                      },
                    }}
                  />
                </Button>
              </Box>
              <Typography
                sx={{ display: { xs: "none", md: "block" } }}
                variant="body2"
                color="text.secondary"
              >
                {FiletredData.length} of {notification.length} Notifications
              </Typography>
            </Box>
            <Box>
              {/* Dense toggle */}
              <Tooltip
                sx={{ display: { xs: "none", md: "block" } }}
                title="Dense padding"
                arrow
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={dense}
                      onChange={handleChangeDense}
                      color="primary"
                    />
                  }
                />
              </Tooltip>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              textAlign: "left",
              marginLeft: "20px",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <Typography
              sx={{ display: { xs: "block", md: "none" }, textAlign: "left" }}
              variant="body2"
              color="text.secondary"
            >
              {FiletredData.length} of {notification.length} Notification
            </Typography>
            <Box sx={{ display: { xs: "block", md: "none" } }}>
              <Button
                onClick={handleClick}
                variant="outlined"
                sx={{
                  minWidth: "20px",
                  padding: "4px 4px",
                  borderRadius: "10px",
                  fontWeight: 600,
                  textTransform: "none",
                  color: "#17479e",
                  borderColor: "#17479e",
                  backgroundColor: "#f8f9ff",
                  transition: "all 0.3s ease",
                  boxShadow: "0 0 0 rgba(0,0,0,0)",
                  "&:hover": {
                    backgroundColor: "#17479e",
                    color: "#fff",
                    borderColor: "#17479e",
                    transform: "scale(1.05)",
                    boxShadow: "0 3px 10px rgba(25, 118, 210, 0.3)",
                  },
                  "&:active": {
                    transform: "scale(0.98)",
                  },
                }}
              >
                <RefreshIcon
                  sx={{
                    animation: rotating ? "spin 0.6s linear" : "none",
                    "@keyframes spin": {
                      "0%": { transform: "rotate(0deg)" },
                      "100%": { transform: "rotate(360deg)" },
                    },
                  }}
                />
              </Button>
            </Box>
            <Tooltip
              sx={{ display: { xs: "block", md: "none" } }}
              title="Dense padding"
              arrow
            >
              <FormControlLabel
                control={
                  <Switch
                    checked={dense}
                    onChange={handleChangeDense}
                    color="primary"
                  />
                }
              />
            </Tooltip>
          </Box>
        </CardContent>
      </Card>

      {error && (
        <Alert severity="error" sx={{ m: 2 }} onClose={() => setError(null)}>
          {typeof error === "string"
            ? error
            : error.message || "Something went wrong"}
        </Alert>
      )}

      {/* Loading State */}
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}
      {!isLoading && (
        <Fade in={!isLoading}>
          <Paper
            sx={{
              width: "98%",
              mx: "auto",
              overflow: "hidden",
              boxShadow: 2,
              marginBottom: "20px",
            }}
          >
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table
                stickyHeader
                aria-label="news table"
                size={dense ? "small" : "medium"}
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      padding="checkbox"
                      sx={{
                        backgroundColor: "#17479e",
                        color: "white",
                        position: "sticky",
                        top: 0,
                        zIndex: 3,
                      }}
                    >
                      <Checkbox
                        color="primary"
                        checked={
                          FiletredData.length > 0 &&
                          selectedRows.length === FiletredData.length
                        }
                        indeterminate={
                          selectedRows.length > 0 &&
                          selectedRows.length < FiletredData.length
                        }
                        onChange={handleSelectAll}
                        sx={{
                          color: "white",
                          "&.Mui-checked": { color: "white" },
                        }}
                      />
                    </TableCell>
                    {visibleColumnDefs.map((c) => (
                      <TableCell
                        key={c.key}
                        sx={{
                          backgroundColor: "#17479e",
                          color: "white",
                          fontWeight: 600,
                          ...c.cellCss,
                          position: "sticky",
                          top: 0,
                          zIndex: 3,
                        }}
                        sortDirection={orderBy === c.key ? order : false}
                      >
                        <TableSortLabel
                          active={orderBy === c.key}
                          direction={orderBy === c.key ? order : "asc"}
                          onClick={() => handleSort(c.key)}
                          sx={{
                            color: "#ffffff !important",
                            "&.Mui-active": {
                              color: "#ffffff !important",
                            },
                            "& .MuiTableSortLabel-icon": {
                              color: "#ffffff !important",
                            },
                          }}
                        >
                          {c.label}
                        </TableSortLabel>
                      </TableCell>
                    ))}
                    {/* <TableCell
                      sx={{
                        backgroundColor: "#17479e",
                        color: "white",
                        fontWeight: 600,
                        minWidth: 120,
                        textAlign: "center",
                      }}
                    >
                      Actions
                    </TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(FiletredData) && FiletredData.length > 0 ? (
                    FiletredData.map((row) => {
                      const selected = isSelected(row.userId);
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                          selected={selected}
                          sx={{}}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              checked={selected}
                              sx={{
                                color: "#17479e",
                                "&.Mui-checked": { color: "#17479e" },
                              }}
                              onChange={() => handleRowSelect(row.userId)}
                            />
                          </TableCell>
                          {visibleColumnDefs.map((c) => (
                            <TableCell
                              key={c.key}
                              sx={{ padding: "10px 10px", ...c.cellCss }}
                            >
                              {(() => {
                                const value = c.getValue(row);
                                const key = c.key;

                                // Optional debug

                                if (key === "active" || key === "isNational") {
                                  return getBooleanChip(value);
                                }

                                if (key === "contentType") {
                                  return getContentTypeChip(value);
                                }

                                return value;
                              })()}
                            </TableCell>
                          ))}
                          {/* <TableCell
                                  sx={{
                                    align: "center",
                                    padding: "10px 10px",
                                    minWidth: "120px",
                                  }}
                                >
                                  <Stack
                                    direction="row"
                                    spacing={0.5}
                                    justifyContent="center"
                                  >
                                    <Tooltip
                                      title="Edit Banner"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        color="primary"
                                        onClick={() => handleEditClick(row)}
                                        size="small"
                                        sx={{
                                          "&:hover": {
                                            backgroundColor: "primary.light",
                                            color: "white",
                                          },
                                        }}
                                      >
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip
                                      title="Delete Banner"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        color="error"
                                        onClick={() => handleClickOpen(row.id)}
                                        size="small"
                                        sx={{
                                          "&:hover": {
                                            backgroundColor: "error.light",
                                            color: "white",
                                          },
                                        }}
                                      >
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </Stack>
                                </TableCell> */}
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={visibleColumnDefs.length + 1}
                        sx={{ textAlign: "center", py: 4 }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          <Typography variant="h6" color="text.secondary">
                            {searchQuery
                              ? "No Notifications found matching your search"
                              : "No Notifications available"}
                          </Typography>
                          {searchQuery && (
                            <Button
                              variant="outlined"
                              onClick={() => setSearchQuery("")}
                              startIcon={<SearchIcon />}
                            >
                              Clear Search
                            </Button>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 30, 50, 100]}
              component="div"
              count={totalElements}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                borderTop: "1px solid",
                borderColor: "divider",
                "& .MuiTablePagination-toolbar": {
                  paddingLeft: 2,
                  paddingRight: 2,
                },
              }}
            />
          </Paper>
        </Fade>
      )}
      <NotificationModal
        // newsEdit={newsEdit}
        selectedUsers={selectedRows}
        open={openNew}
        onClose={handleNewClose}
        // onSuccess={handleFormSuccess}
      />
    </>
  );
}

export default Notification;
